"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompareStickyBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const cotopaxi_1 = require("@as/cotopaxi");
const ScreenWidthConstants_1 = require("../../../constants/ScreenWidthConstants");
const SliderConstants_1 = require("../../../constants/SliderConstants");
const DOMElementsConstants_1 = require("../../../constants/DOMElementsConstants");
const GeneralConstants_1 = require("../../../constants/GeneralConstants");
const CompareStickyBarSlide_1 = require("./CompareStickyBarSlide");
const andes_react_1 = require("@yonderland/andes-react");
const COMPARE_STICKY_POSITION_DESKTOP = 700;
const CompareStickyBar = ({ comparisonProducts, setSwiperInstance, }) => {
    const isDesktop = (0, cotopaxi_1.useMediaQueryMatchesOnDesktop)();
    const [hidden, setHidden] = (0, react_1.useState)(true);
    const [navigationEl, setNavigationEl] = (0, react_1.useState)(null);
    const [isNavDisplayed, setIsNavDisplayed] = (0, react_1.useState)(false);
    const [shouldRender, setShouldRender] = (0, react_1.useState)(false);
    const [compareStickyCarouselSwiper, setCompareStickyCarouselSwiper] = (0, react_1.useState)(null);
    const setSwiper = (swiper) => {
        setCompareStickyCarouselSwiper(swiper);
        setSwiperInstance(swiper);
    };
    (0, react_1.useEffect)(() => {
        if (compareStickyCarouselSwiper !== null) {
            compareStickyCarouselSwiper.update();
        }
    }, [comparisonProducts, compareStickyCarouselSwiper]);
    (0, react_1.useEffect)(() => {
        const navigation = document.querySelector(DOMElementsConstants_1.NAVIGATION_HORIZONTAL);
        setNavigationEl(navigation);
        // This needed because the navigation menu gets hidden after the page loads with a delay
        setTimeout(() => setShouldRender(true), GeneralConstants_1.DELAY.DELAY_100);
        return () => setSwiperInstance(null);
    }, []);
    const compareStickyCarouselConfig = {
        variant: cotopaxi_1.CarouselVariant.PRODUCT_TILE_NORMAL,
        arrowsConfig: {
            color: cotopaxi_1.SliderNavColor.BASE,
            variant: cotopaxi_1.SliderNavVariant.CIRCLE,
        },
        showPagination: false,
        fullWidth: true,
        configurationOverrides: {
            preventClicks: true,
            slidesPerView: 'auto',
            spaceBetween: SliderConstants_1.SLIDE_SPACING.MOBILE,
            watchOverflow: true,
            getSwiper: setSwiper,
            breakpoints: {
                [ScreenWidthConstants_1.MIN_SCREEN_WIDTH_TABLET]: {
                    slidesPerView: 'auto',
                    spaceBetween: SliderConstants_1.SLIDE_SPACING.TABLET,
                },
                [ScreenWidthConstants_1.MIN_SCREEN_WIDTH_DESKTOP]: {
                    slidesPerView: SliderConstants_1.SLIDES_AMOUNT_DESKTOP,
                    spaceBetween: SliderConstants_1.SLIDE_SPACING.DESKTOP,
                },
                [ScreenWidthConstants_1.MIN_SCREEN_WIDTH_DESKTOP_LARGE]: {
                    slidesPerView: SliderConstants_1.SLIDES_AMOUNT_DESKTOP_LARGE,
                    spaceBetween: SliderConstants_1.SLIDE_SPACING.DESKTOP,
                },
            },
        },
    };
    const compareSlide = (0, react_1.useCallback)((product) => ((0, jsx_runtime_1.jsx)(cotopaxi_1.Column, { gutter: false, grid: 4, desktop: 3, tablet: 4, tabletSmall: 4, children: (0, jsx_runtime_1.jsx)(CompareStickyBarSlide_1.CompareStickyBarSlide, { product: product }) }, `${product.productCode}${product.colourId}`)), [comparisonProducts]);
    (0, cotopaxi_1.useScrollPosition)(({ currPos }) => {
        if (navigationEl) {
            if (!isDesktop) {
                setIsNavDisplayed(!navigationEl.classList.contains(DOMElementsConstants_1.NAVIGATION_HORIZONTAL_COLLAPSE));
            }
            else {
                if (isNavDisplayed) {
                    setIsNavDisplayed(false);
                }
            }
        }
        setHidden(Math.abs(currPos.y) < COMPARE_STICKY_POSITION_DESKTOP);
    }, [navigationEl, isNavDisplayed, isDesktop]);
    if (!shouldRender) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(cotopaxi_1.StickyBar, { isHidden: hidden, variant: cotopaxi_1.StickyBarVariant.COMPARE, withNavBar: isNavDisplayed, children: (0, jsx_runtime_1.jsx)(andes_react_1.Container, { column: "content", children: (0, jsx_runtime_1.jsx)(cotopaxi_1.Carousel, Object.assign({}, compareStickyCarouselConfig, { children: comparisonProducts.map(compareSlide) })) }) }));
};
exports.CompareStickyBar = CompareStickyBar;
